module.exports = __webpack_public_path__ + "static/img/19017B_1_2_3_C_20230527_LC.2a63350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/19017B_1_2_3_C_20230527_LC.png
// module id = pQ6S
// module chunks = 0